import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { LabelDisplayItemComponent } from '@lib/label';
import { AttributeComponent } from '@lib/ui';
import { CommonModule as ProgetSharedCommonModule } from '@proget-shared/_common';
import { TranslateModule } from '@proget-shared/translate';
import { EllipsisModule } from '@proget-shared/ui/ellipsis';
import { TooltipModule } from '@proget-shared/ui/tooltip';
import { map } from 'rxjs';

import { LimitedElementsComponent } from '../../component/limited-items/limited-items.component';
import { Attribute, User } from '../../model';

@Component({
  selector: 'lib-my-card',
  templateUrl: './my-card.component.html',
  styleUrls: ['./my-card.component.scss'],
  imports: [
    TranslateModule,
    TooltipModule,
    EllipsisModule,
    AttributeComponent,
    ProgetSharedCommonModule,
    LimitedElementsComponent,
    LabelDisplayItemComponent,
  ],
})
export class MyCardComponent {
  protected attributes: Partial<Attribute>[] = [];
  protected user: User;

  private readonly destroyRef = inject(DestroyRef);
  private readonly activatedRoute = inject(ActivatedRoute);

  constructor() {
    this.activatedRoute.data
      .pipe(
        map((data) => data.user as User),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (user) => {
          this.user = user;
          this.prepareAttributes();
        },
      });
  }

  private prepareAttributes(): void {
    this.attributes = [
      {
        displayNameKey: 'library.user_card.attributes.display_name.option.email',
        value: this.user.email,
      },
      {
        displayNameKey: 'library.user_card.attributes.display_name.option.username',
        value: this.user.username,
      },
      {
        displayNameKey: 'library.user_card.attributes.display_name.option.phone',
        value: this.user.phoneNumber,
      },
    ];
  }
}
